import { produce } from "immer";
import * as Actions from "pages/Mail/ReadMessage/store/conversationActions";

import deepmerge from "deepmerge";
import combineMerge from "config/combineMerge";
import idFixer from "utils/idFixer";
import * as reminderActions from "pages/Mail/Messages/store/reminderActions";
import { applyReminderFields } from "pages/Mail/helpers/reminders";

const initialState = { byId: {}, allIds: [], ntimes: {} };
const conversationReducer = produce((draft, action) => {
  switch (action.type) {
    case Actions.FETCH_CONVERSATION_SUCCESS: {
      const payload = action.payload;
      const id = idFixer(payload.id);
      const conversations = payload.conversations;
      const conversationIds = payload.conversations.map(message =>
        idFixer(message.id)
      );

      const byId = conversations.reduce((obj, message) => {
        message = {
          ...message,
          listingType: "message",
          id: idFixer(message.id)
        };
        obj[message.id] = {
          ...message,
          status: "idle"
        };

        return obj;
      }, {});

      draft.byId = byId;
      draft.allIds = conversationIds;

      draft.ntimes[id] = 0;
      break;
    }

    case Actions.FETCH_SUB_CONVERSATIONS_MESSAGE_SUCCESS: {
      const payload = action.payload;
      const { id, data } = payload;

      const byId = {
        [id]: data
      };

      const merged = deepmerge(draft.byId, byId, {
        arrayMerge: combineMerge
      });
      applyReminderFields(merged[id], data);
      draft.byId = merged;
      break;
    }

    case Actions.REMOVE_MESSAGE_FROM_CONVERSATION: {
      const id = action.payload;
      if (id in draft.byId) {
        draft.byId[id].status = "deleted";
      }

      break;
    }

    case reminderActions.SET_MESSAGE_REMINDERS: {
      const { id, ...fields } = action.payload;
      applyReminderFields(draft.byId[id], fields);
      break;
    }

    case Actions.ADD_NTIMES: {
      const { messageId, conversationId } = action.payload;
      draft.ntimes[messageId] = conversationId;
      break;
    }
    default:
      return draft;
  }
}, initialState);

export default conversationReducer;
